module.exports = __webpack_public_path__ + "static/media/taxify.5b301a54.jpg";